import { render, staticRenderFns } from "./PredefinedPositionAttrs.vue?vue&type=template&id=583c021c"
import script from "./PredefinedPositionAttrs.vue?vue&type=script&lang=js"
export * from "./PredefinedPositionAttrs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports